(function(){
if(window.__cgghInit)return;window.__cgghInit=true;
function money(n){return '$'+(Math.round(n*100)/100).toFixed(2);}
function openCart() {
  if (typeof window.openUpnovaCart === "function") {
    window.openUpnovaCart();
    return true;
  }
  if (typeof window.SLIDECART_UPDATE === "function") {
    window.SLIDECART_UPDATE(function () {
      typeof window.SLIDECART_OPEN === "function" && window.SLIDECART_OPEN();
    });
    return true;
  }
  if (typeof window.SLIDECART_OPEN === "function") {
    window.SLIDECART_OPEN();
    return true;
  }
  return false;
}
function ladder(c){
  var box=document.querySelector('[data-cggh-ladder]');if(!box||!c)return;
  var t=(c.total_price||0)/100,steps=[].slice.call(box.querySelectorAll('[data-cggh-step]')),max=0,next=null;
  steps.forEach(function(s){
    var at=Number(s.dataset.at),hit=t>=at;if(at>max)max=at;
    s.classList.toggle('is-hit',hit);
    s.querySelector('[data-cggh-state]').textContent=hit?'Unlocked':(t>0?money(at-t)+' to go':'Spend $'+at);
    if(!hit&&!next)next={at:at,what:s.dataset.what};
  });
  box.querySelector('[data-cggh-bar]').style.width=(max?Math.min(100,Math.round(t/max*100)):0)+'%';
  box.querySelector('[data-cggh-msg]').textContent=t===0?box.dataset.empty:(next?money(next.at-t)+' away from '+next.what.toLowerCase():'You unlocked every reward');
}
var cache={};
function loadCards(h,sort){
  var k=h+'|'+sort;
  if(!cache[k]){
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    cache[k]=fetch(root+'collections/'+h+'?section_id=cgg-home-cards&sort_by='+sort).then(function(r){if(!r.ok)throw r;return r.text();}).then(function(t){
      var doc=new DOMParser().parseFromString(t,'text/html');
      return [].slice.call(doc.querySelectorAll('[data-cggh-card]')).map(function(el){var a=el.querySelector('a[href]');return{type:el.getAttribute('data-cggh-type')||'',key:a?a.getAttribute('href').split('?')[0]:'',html:el.outerHTML};});
    });
    cache[k].catch(function(){delete cache[k];});
  }
  return cache[k];
}
function applyType(panel){
  var type=panel.dataset.cgghSel||'all';
  [].slice.call(panel.querySelectorAll('[data-cggh-grid]')).forEach(function(g){
    var tp=g.closest('[data-cggh-panel]');if(tp&&tp.hidden)return;
    if(g._orig===undefined)g._orig=g.innerHTML;
    if(g.dataset.cgghShown===type)return;
    g.classList.add('is-loading');
    Promise.all([loadCards(g.dataset.handle,'created-descending'),loadCards(g.dataset.handle,'best-selling')]).then(function(res){
      if((panel.dataset.cgghSel||'all')!==type)return;
      var lim=Number(g.dataset.limit)||8,half=Math.max(2,Math.round(lim/2));
      function pick(list,skip){return list.filter(function(c){return(type==='all'||c.type===type)&&!skip[c.key];});}
      var fresh=pick(res[0],{}).slice(0,half),seen={};
      fresh.forEach(function(c){seen[c.key]=1;});
      var best=pick(res[1],seen).slice(0,half);
      function row(label,list){return list.length?'<h4 class="cggh-rowh">'+label+'</h4>'+list.map(function(c){return c.html;}).join(''):'';}
      var html=row('New arrivals',fresh)+row('Best sellers',best);
      g.innerHTML=html||'<p class="cggh-none">'+(type==='all'?'Nothing':'No '+type)+' in stock here right now.</p>';
      g.dataset.cgghShown=type;
    }).catch(function(){g.innerHTML=g._orig;g.dataset.cgghShown='';}).then(function(){g.classList.remove('is-loading');});
  });
}
function refresh(){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(ladder).catch(function(){});}
document.addEventListener('click',function(e){
  var root=e.target.closest('.cggh');if(!root)return;
  var s=e.target.closest('[data-cggh-size]');
  if(s){
    var card=s.closest('[data-cggh-card]');
    card.querySelectorAll('[data-cggh-size]').forEach(function(b){b.setAttribute('aria-pressed',String(b===s));});
    card.querySelector('[data-cggh-price]').textContent=s.dataset.price;
    card.querySelector('[data-cggh-compare]').textContent=s.dataset.compare||'';
    var off=card.querySelector('[data-cggh-off]');
    if(off){if(s.dataset.off){off.textContent=s.dataset.off+'% OFF';off.hidden=false;}else{off.hidden=true;}}
    var add=card.querySelector('[data-cggh-add]');add.dataset.id=s.dataset.id;add.classList.remove('is-done');add.textContent='Add '+s.dataset.label+' to cart';
    return;
  }
  var a=e.target.closest('[data-cggh-add]');
  if(a){
    if(a.disabled)return;a.disabled=true;var old=a.textContent;a.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(a.dataset.id),quantity:1}]})})
    .then(function(r){if(!r.ok)throw r;return fetch('/cart.js',{headers:{'Accept':'application/json'}});}).then(function(r){return r.json();})
    .then(function(c){a.disabled=false;a.classList.add('is-done');a.textContent='✓ Added · add another';ladder(c);if(!openCart())window.location.href='/cart';})
    .catch(function(){a.disabled=false;a.textContent='Couldn’t add · try again';setTimeout(function(){a.textContent=old;},2500);});
    return;
  }
  var tb=e.target.closest('[data-cggh-typebtn]');
  if(tb){
    var cp=tb.closest('[data-cggh-catpanel]');if(!cp)return;
    cp.querySelectorAll('[data-cggh-typebtn]').forEach(function(b){b.setAttribute('aria-pressed',String(b===tb));});
    cp.dataset.cgghSel=tb.dataset.cgghTypebtn;applyType(cp);
    return;
  }
  var ct=e.target.closest('[data-cggh-cat]');
  if(ct){
    if(e.metaKey||e.ctrlKey||e.shiftKey||e.button)return;
    var sec=ct.closest('[data-cggh-cats]'),panel=sec&&sec.querySelector('[data-cggh-catpanel="'+ct.dataset.cgghCat+'"]');
    if(!panel)return;
    e.preventDefault();
    var opening=panel.hidden;
    sec.querySelectorAll('[data-cggh-catpanel]').forEach(function(p){p.hidden=true;});
    sec.querySelectorAll('[data-cggh-cat]').forEach(function(b){b.classList.remove('is-on');b.setAttribute('aria-expanded','false');});
    if(opening){panel.hidden=false;ct.classList.add('is-on');ct.setAttribute('aria-expanded','true');applyType(panel);try{panel.scrollIntoView({behavior:'smooth',block:'start'});}catch(_){panel.scrollIntoView();}}
    return;
  }
  var t=e.target.closest('[data-cggh-tab]');
  if(t){
    var wrap=t.closest('[data-cggh-shelves]');
    wrap.querySelectorAll('[data-cggh-tab]').forEach(function(b){b.setAttribute('aria-selected',String(b===t));});
    wrap.querySelectorAll('[data-cggh-panel]').forEach(function(p){p.hidden=p.dataset.cgghPanel!==t.dataset.cgghTab;});
    if(wrap.hasAttribute('data-cggh-catpanel'))applyType(wrap);
  }
});
var prev=window.SLIDECART_UPDATED;
window.SLIDECART_UPDATED=function(c){if(typeof prev==='function'){try{prev(c);}catch(_){}}if(c&&typeof c.total_price==='number')ladder(c);else refresh();};
function loadAllCards(path,qs){
  var key='all|'+path+'?'+qs;
  if(!cache[key]){
    var base=path+'?'+(qs?qs+'&':'')+'section_id=cgg-home-cards';
    var parse=function(t){var doc=new DOMParser().parseFromString(t,'text/html');var src=doc.querySelector('.cggh-cards-src');return{pages:src?Number(src.getAttribute('data-pages'))||1:1,cards:[].slice.call(doc.querySelectorAll('[data-cggh-card]')).map(function(el){return{type:el.getAttribute('data-cggh-type')||'',html:el.outerHTML};})};};
    var get=function(n){return fetch(base+'&page='+n).then(function(r){if(!r.ok)throw r;return r.text();}).then(parse);};
    cache[key]=get(1).then(function(first){
      var extra=[];for(var n=2;n<=Math.min(first.pages,4);n++)extra.push(get(n));
      return Promise.all(extra).then(function(rest){return rest.reduce(function(a,r){return a.concat(r.cards);},first.cards);});
    });
    cache[key].catch(function(){delete cache[key];});
  }
  return cache[key];
}
function strainGrid(){return document.querySelector('#ProductGridContainer motion-list');}
function strainQS(){var p=new URLSearchParams(location.search);['page','section_id','strain'].forEach(function(k){p.delete(k);});return p.toString();}
function applyStrain(bar){
  var type=bar.dataset.strain||'all',g=strainGrid(),host=document.getElementById('ProductGridContainer'),note=bar.querySelector('[data-cggh-strainnote]');
  bar.querySelectorAll('[data-cggh-strain]').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.cgghStrain===type));});
  try{var u=new URL(location.href);if(type==='all')u.searchParams.delete('strain');else u.searchParams.set('strain',type);history.replaceState(history.state,'',u.toString());}catch(_){}
  if(!g||!host)return;
  if(type==='all'){
    if(g._cgghOrig!==undefined){bar._busy=true;g.innerHTML=g._cgghOrig;setTimeout(function(){bar._busy=false;},0);}
    g.removeAttribute('data-cggh-filtered');host.classList.remove('cggh-filtered');if(note)note.textContent='';return;
  }
  if(g._cgghOrig===undefined)g._cgghOrig=g.innerHTML;
  host.classList.add('cggh-is-loading');
  loadAllCards(location.pathname,strainQS()).then(function(cards){
    if((bar.dataset.strain||'all')!==type)return;
    var hit=cards.filter(function(c){return c.type===type;});
    var label=type.charAt(0).toUpperCase()+type.slice(1);
    bar._busy=true;
    g.innerHTML=hit.length?hit.map(function(c){return c.html;}).join(''):'<p class="cggh-none">No '+label+' in stock in this category right now.</p>';
    g.setAttribute('data-cggh-filtered','');host.classList.add('cggh-filtered');
    if(note)note.textContent=hit.length?(hit.length+' '+label+' product'+(hit.length===1?'':'s')+' in stock'):'';
    setTimeout(function(){bar._busy=false;},0);
  }).catch(function(){if(note)note.textContent='Could not load that filter. Try again.';}).then(function(){host.classList.remove('cggh-is-loading');});
}
function strainInit(){
  var bar=document.querySelector('[data-cggh-strainbar]');if(!bar||bar._init)return;bar._init=true;
  bar.addEventListener('click',function(e){var b=e.target.closest('[data-cggh-strain]');if(!b)return;bar.dataset.strain=b.dataset.cgghStrain;applyStrain(bar);});
  var sel=bar.querySelector('[data-cggh-sort]');
  if(sel)sel.addEventListener('change',function(){var u=new URL(location.href);u.searchParams.set('sort_by',sel.value);u.searchParams.delete('page');location.assign(u.toString());});
  var s=new URLSearchParams(location.search).get('strain');
  if(s&&/^(indica|sativa|hybrid)$/.test(s)){bar.dataset.strain=s;applyStrain(bar);}
  var root=document.querySelector('.collection')||document.body;
  if(window.MutationObserver)new MutationObserver(function(){
    if(bar._busy||!bar.dataset.strain||bar.dataset.strain==='all')return;
    var g=strainGrid();if(g&&!g.hasAttribute('data-cggh-filtered')&&!g._cgghPending){g._cgghPending=true;applyStrain(bar);}
  }).observe(root,{childList:true,subtree:true});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',strainInit);else strainInit();
var tm=null;function soon(){clearTimeout(tm);tm=setTimeout(refresh,400);}
try{new PerformanceObserver(function(l){l.getEntries().forEach(function(en){if(/\/cart\/(add|change|update|clear)/.test(en.name))soon();});}).observe({type:'resource',buffered:false});}catch(_){}
document.addEventListener('visibilitychange',function(){if(!document.hidden)soon();});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh);else refresh();
})();
